<nb-card class="order-menu-dialog">
  <nb-card-header class="order-menu-header">
    <div class="order-menu-titlebar">
      <div>
        <p class="order-menu-kicker">{{ 'Menu' | translate }}</p>
        <h2>{{ dialogTitle | translate }}</h2>
        <span>{{ dialogSubtitle | translate }}</span>
      </div>
      <button type="button" class="btn order-menu-close" (click)="closeDialog()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body class="order-menu-body">
    <div *ngIf="loading" class="order-menu-loading">
      <div class="spinner-border lodingcolor" role="status">
        <span class="visually-hidden">{{ 'Loading...' | translate }}</span>
      </div>
    </div>

    <div *ngIf="!loading && categoryTitle" class="order-menu-layout">
      <section class="menu-workspace">
        <div class="category-tabs">
          <button
            *ngFor="let category of visibleCategories; trackBy: trackCategory"
            type="button"
            class="category-tab"
            [class.active]="activeCategoryId === category.id"
            (click)="selectCategory(category)">
            <span>{{ displayTitle(category) }}</span>
            <small>{{ filteredCategoryItems(category).length }}</small>
          </button>
        </div>

        <div class="menu-catalog">
          <div
            *ngFor="let category of visibleCategories; trackBy: trackCategory"
            class="menu-category-section"
            [id]="categoryDomId(category.id)">
            <div class="category-heading">
              <div>
                <h3>{{ displayTitle(category) }}</h3>
                <p *ngIf="displayDescription(category)">{{ displayDescription(category) }}</p>
              </div>
              <span>{{ filteredCategoryItems(category).length }} {{ 'Items' | translate }}</span>
            </div>

            <div class="menu-items-grid">
              <article
                *ngFor="let item of filteredCategoryItems(category); trackBy: trackItem"
                class="menu-item-card"
                [class.unavailable]="isUnavailable(item)">
                <div class="item-media">
                  <img [src]="item.image || 'assets/images/image-upload.svg'" [alt]="displayTitle(item)" (error)="changeSource($event)" />
                  <span *ngIf="isUnavailable(item)" class="item-badge">{{ 'Unavailable' | translate }}</span>
                </div>

                <div class="item-content">
                  <div class="item-title-row">
                    <h4>{{ displayTitle(item) }}</h4>
                    <strong>{{ item.price | dividePrice }} {{ (item.currency?.value ?? '') | translate }}</strong>
                  </div>
                  <p>{{ displayDescription(item) || ('No description' | translate) }}</p>

                  <div class="item-actions">
                    <button
                      *ngIf="itemCount(item.id) < 1; else itemStepper"
                      type="button"
                      class="add-item-button"
                      [disabled]="isUnavailable(item)"
                      (click)="addItem(item)">
                      <i class="bi bi-plus-lg"></i>
                      <span>{{ 'Add' | translate }}</span>
                    </button>

                    <ng-template #itemStepper>
                      <div class="quantity-stepper primary-stepper">
                        <button type="button" [disabled]="newItemCount(item.id) < 1" (click)="removeItem(item.id)">
                          <i class="bi bi-dash"></i>
                        </button>
                        <span>{{ itemCount(item.id) }}</span>
                        <button type="button" [disabled]="isUnavailable(item)" (click)="addItem(item)">
                          <i class="bi bi-plus"></i>
                        </button>
                      </div>
                    </ng-template>

                    <button
                      type="button"
                      class="note-button"
                      [disabled]="isUnavailable(item)"
                      (click)="addItemWithNote(item)">
                      <i class="bi bi-pencil-square"></i>
                      <span>{{ 'Note' | translate }}</span>
                    </button>
                  </div>
                </div>
              </article>
            </div>
          </div>

          <app-is-empty-message *ngIf="!visibleCategories.length" [message]="'No menu items found'"></app-is-empty-message>
        </div>
      </section>

      <aside class="cart-panel" [class.cart-expanded]="isCartExpanded">
        <button
          type="button"
          class="cart-drag-handle"
          (click)="toggleCart()"
          (touchstart)="startCartDrag($event)"
          (touchend)="finishCartDrag($event)"
          (pointerdown)="startCartDrag($event)"
          (pointerup)="finishCartDrag($event)">
          <span></span>
        </button>

        <div class="cart-panel-header">
          <div>
            <p>{{ 'Current order' | translate }}</p>
            <strong>{{ displayCartQuantity }} {{ 'Items' | translate }}</strong>
          </div>
          <span>{{ displayCartTotal | dividePrice }} {{ 'AED' | translate }}</span>
        </div>

        <div *ngIf="selectedItems.length; else emptyCart" class="cart-items">
          <div *ngFor="let selected of selectedItems" class="cart-item">
            <div class="cart-item-main">
              <p>{{ displayTitle(selected.item) }}</p>
              <small>{{ selected.notes || ('No notes' | translate) }}</small>
            </div>
            <div class="cart-item-meta">
              <span>{{ selected.total | dividePrice }} {{ (selected.item.currency?.value ?? '') | translate }}</span>
            </div>
            <div class="cart-item-actions">
              <div class="cart-stepper">
                <button type="button" [disabled]="selected.newQuantity < 1" (click)="removeSelectedSingle(selected)">
                  <i class="bi bi-dash"></i>
                </button>
                <strong>{{ selected.quantity }}</strong>
                <button type="button" [disabled]="isUnavailable(selected.item)" (click)="addItem(selected.item)">
                  <i class="bi bi-plus"></i>
                </button>
              </div>
              <button
                *ngIf="selected.newQuantity > 0"
                type="button"
                class="cart-delete-button"
                (click)="removeSelectedItem($event, selected)"
                (pointerup)="removeSelectedItem($event, selected)"
                (touchend)="removeSelectedItem($event, selected)"
                (pointerdown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
                [disabled]="selected.newQuantity < 1"
                [attr.aria-label]="'Delete item' | translate">
                <i class="bi bi-trash3"></i>
              </button>
            </div>
          </div>
        </div>

        <ng-template #emptyCart>
          <div class="cart-empty">
            <i class="bi bi-bag"></i>
            <p>{{ 'No items selected' | translate }}</p>
          </div>
        </ng-template>
      </aside>
    </div>

    <app-is-empty-message *ngIf="!loading && !categoryTitle" [message]="'No menu items found'"></app-is-empty-message>
  </nb-card-body>

  <nb-card-footer class="order-menu-footer px-0">
    <app-add-order-button
      [tableIdInput]="tableId"
      [orderIdInput]="orderId"
      [returnUrlInput]="returnUrl"
      [isItemsToOrder]="isItemsToOrder"
      [closeOnSuccess]="true"
      (orderCompleted)="onOrderCompleted($event)"
      class="w-100 h-100"></app-add-order-button>
  </nb-card-footer>
</nb-card>
